<template >
  <div v-if="isRouterAlive" id="chatBox" >
    <div class="popBox" v-if="outStatus" >
      <div class="phoneBox">
        <div class="phone_top">提示</div>
        <div class="tipContent">您已被移出聊天室，如有疑问请联系客服</div>
        <div class="btnBox">
          <div class="btn20" @click="confire" >确认</div>
          
        </div>
      </div>
    </div>



  <div class="popBox" v-if="tiren"  >
      <div class="phoneBox">
      <div class="phone_top">操作确认</div> 
       
<div style=" line-height: 5rem">
    <ul>
            <li style="justify-content: center;" v-if="connt <= 3">
              您确定要禁言此用户{{valuE}}
              <span style="color:black;" v-if="valuE != '永久'">小时</span>吗?
            </li>
            <li style="justify-content: center;" v-else>
              您确定要踢出此用户{{valuE}}
              <span style="color:black;" v-if="valuE != '永久'">小时</span>吗?
            </li>
       </ul>
       </div>

        <div class="btnBox">
          <div class="btn20" @click="sendBannedAndOUt">确认</div>
          <div class="btn1 btn2" @click="Cancel">取消</div>
        </div>
      </div>
    </div>

    <div class="popBox1" v-if="outStatus1">

    </div>

    <div class="chatBox" ref="imageToFile">
      <div class="BigContent">
        <!-- @了你-->
        <div class="AtUser" v-if="atTip">
          <div class="name_me" @click="closeAt">
            {{atName}} @了你
            <span>&nbsp;|&nbsp;</span>
            <img src="./img/infor_btn_close@2x.png" alt @click="closeAt" />
          </div>
        </div>
      <div v-if="duankailianjie"
            style="position:fixed;top:0; left:0;width:100%;height:100%;z-index:9997;"
          ></div>
        <div class="boxContent">
          <div v-if="duankailianjie" class="vanloading">
            <div>连接已断开,请重新连接</div>
          </div>
          <div v-if="isLoading" class="van_loading">
            <div>连接中...</div>
          </div>

           <div class="rightClick" v-if="rightclickShow">
                  <div class="phone_top1">操作</div>
                      <ul >
                        <li @click="confige(i+1,v.value,i)" v-for="(v,i) in  itemList" :key="i"> 
                          <span style="color:black;" v-if="i<=2">禁言</span>
                          <span style="color:black;" v-else>踢出</span>
                          <span style="color: #11a23c;" v-if="v.value === '永久'">{{v.value}}</span>
                          <span style="color: #11a23c;" v-else>{{v.value}}小时</span>
                        </li>
                      </ul>
            </div>
         <!-- :class="{boxInfo::-webkit-scrollbar}" -->
           <div class="boxInfo" id="dialogue_box">
          
            <!-- 后台获取聊天记录历史 -->
            <div v-if="More" @click="Morenews" class="more">查看更多消息</div>
            <div v-for="(v,i) in tableData" :key="i">
              <div style="z-index:0" class="others" v-show="v.from_user_id != myid && v.from_user_id != 0 && v.type == 0">
                <div class="chatPlazatime" style="justify-content: center;">{{v.create_time}}</div>
                <div style="margin-top:1rem;">
                 
                  <div v-if="v.chat_admin==1" class="others_img" @click="atThisUser(v.from_user_id,v.nick_name)" @contextmenu.prevent="" >
                    <img :src="v.image_path" alt v-if="v.image_path" crossorigin="anonymous" @error="getError" />
              
                    <img src="./img/me_img_default@2x.1.png" alt v-else />
                  </div>

                   <div v-else class="others_img" @click="atThisUser(v.from_user_id,v.nick_name)"  @contextmenu.prevent="getBannedOut(v.from_user_id,v.nick_name)">
                    <img :src="v.image_path" alt v-if="v.image_path" crossorigin="anonymous" @error="getError" />
                    <img src="./img/me_img_default@2x.1.png" alt v-else />
                  </div>

                   
                  <div>
                    <div class="others_name">
                      <span class="level" v-if="v.chat_admin==1">管理员</span>
                      <span class="level" v-else>Lv. {{v.login_level}}</span>
                      {{v.nick_name}}
                    </div>
                    <img :src="v.pic" v-if="v.pic" class="chatPhoto" @click="bigPhoto(v.pic)" /> 
                    <div class="others_content" v-else>
                      <div v-html="v.content" v-if="v.content"></div>
                      <img :src="v.face" v-show="v.face" class="facePhoto" />
                    </div>
                    
                  </div>
                </div>
              </div>


              <!--禁言-->
              <div class="jiet" v-show="v.from_user_id != myid && v.type == 1" style="justify-content: center;">
                <div class="chatPlazatime1" style="justify-content: center;">{{v.create_time}}</div>
                <p class="Kickout">
                  用户
                  <span>{{v.nick_name}}</span>已被禁言
                  <span v-if='v.time=="永久"'>{{v.time}}</span><span v-else>{{v.time}}小时</span>&nbsp;不得发言
                </p>
              </div>

  

              <!-- 踢出 -->
              <div class="jiet"   v-show="v.from_user_id != myid && v.type == 2" style="justify-content: center;">
                <div class="chatPlazatime1" style="justify-content: center;">{{v.create_time}}</div>
                <p class="Kickout">
                  用户
                  <span>{{v.nick_name}}</span>已被踢出
                  <span v-if='v.time=="永久"'>{{v.time}}</span><span v-else>{{v.time}}小时</span>&nbsp;不得入内
                </p>
              </div>
              <!--自己-->
              <div style="z-index:0" class="oneself" v-show="v.from_user_id == myid && v.type == 0">
                <!-- @ -->
                <div class="chatPlazatime1" style="justify-content: center;">{{v.create_time}}</div>
                <div style="margin-top:1rem;display: flex;">
                  <div>
                    <div class="oneself_name">
                      {{v.nick_name}}
                      <span class="level" v-if="v.chat_admin==1">管理员</span>
                      <span class="level" v-else>Lv. {{v.login_level}}</span>
                    </div>
                
                    <img :src="v.pic" v-if="v.pic" class="chatPhoto" @click="bigPhoto(v.pic)" />
                    <div class="oneself_content" v-else>
                      <div v-html="v.content" v-if="v.content"></div>
                      <img :src="v.face" v-if="v.face" class="facePhoto" />
                    </div>
                  </div>

                  <div class="oneself_img">
                    <img
                      :src="v.image_path"
                      @error="getError"
                      v-if="v.image_path"
                      @click="atThisUser(v.from_user_id,v.nick_name)"
                    />
                    <img src="./img/me_img_default@2x.1.png" v-else />
                  </div>
                </div>
              </div>
            </div>
             
            <!-- 本地聊天记录 -->
            <div v-for="v in chatContent" :key="v.id">
              <div style="z-index:0" class="others" v-show="v.client_id != client_id && v.client_id != 'admin'  && !v.type">
                <div class="chatPlazatime" style="justify-content: center;">{{v.time}}</div>
                <div style="margin-top:1rem;">
                  <div v-if="v.chat_admin==1" class="others_img" @click="atThisUser(v.userId,v.name)" @contextmenu.prevent="">
                    <img :src="v.img" alt v-if="v.img" @error="getError" />
                    <img src="./img/me_img_default@2x.1.png" alt v-else />
                  </div>

                  <div  v-else class="others_img" @click="atThisUser(v.userId,v.name)"  @contextmenu.prevent="getBannedOut(v.from_user_id,v.nick_name)">
                    <img :src="v.img" alt v-if="v.img" @error="getError" />
                    <img src="./img/me_img_default@2x.1.png" alt v-else />
                  </div>

                  <div>
                    <div class="others_name">
                      {{v.name}}
                      <span class="level" v-if="v.chat_admin==1">管理员</span>
                      <span class="level" v-else>Lv. {{v.login_level}}</span>
                    </div>
                    <img :src="v.pic" v-if="v.pic" class="chatPhoto" @click="bigPhoto(v.pic)" />
                    <div class="others_content" v-else>
                      <div v-html="v.conent" v-if="v.conent"></div>
                      <img :src="v.face" v-show="v.face" class="facePhoto" />
                    </div>
                  </div>
                </div>
              </div>

              <!--禁言-->
              <div class="jiet" v-show="v.type=='banned'" style="justify-content: center;">
                <div class="chatPlazatime1" style="justify-content: center;">{{v.time}}</div>
                <p class="Kickout">
                     用户
                  <span>{{v.name}}</span>已被禁言
                  <span v-if='v.bannedtime=="永久"'>{{v.bannedtime}}</span><span v-else>{{v.bannedtime}}小时</span>&nbsp;不得发言
                </p>
              </div>
              <!--进来用户-->
              <div class="jiet" v-show="v.type=='login_name'" style="justify-content: center;">
                <div class="chatPlazatime1" style="justify-content: center;">{{v.time}}</div>
                <p class="Kickout">
                     用户
                  <span>{{v.name}}</span>进来了
                </p>
              </div>
              <!-- 踢出 -->
              <div class="jiet" v-show="v.type=='out_status'" style="justify-content: center;">
                <div class="chatPlazatime1" style="justify-content: center;">{{v.time}}</div>
                <p class="Kickout">
                  用户
                   <span>{{v.name}}</span>已被踢出
                   <span v-if='v.out_nametime=="永久"'>{{v.out_nametime}}</span><span v-else>{{v.out_nametime}}小时</span>&nbsp;不得入内
                </p>
              </div>

              <div style="z-index:0" class="oneself" v-show="v.client_id == client_id && !v.type">
                <!-- @ -->
                <div class="chatPlazatime1" style="justify-content: center;">{{v.time}}</div>
                <div style="margin-top:1rem;display: flex;">
                  <div>
                    <div class="oneself_name">
                      {{v.name}}
                      <span class="level" v-if="v.chat_admin==1" >管理员</span>
                      <span class="level" v-else>Lv. {{v.login_level}}</span>
                    </div>
                  
                    <img :src="v.pic" v-if="v.pic" class="chatPhoto" @click="bigPhoto(v.pic)" />
                   
                    <div class="oneself_content" v-else>
                      <div v-html="v.conent" v-if="v.conent"></div>
                      <img :src="v.face" v-if="v.face" class="facePhoto" />
                    </div>
                  </div>
                  <div class="oneself_img" @click="atThisUser(v.userId,v.name)">
                    <img :src="v.img" alt v-if="v.img" @error="getError" />
                    <img src="./img/me_img_default@2x.1.png" v-else />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="boxInput">
            <div class="boxInput">
              <div class="input_top">
                <img src="./img/chat_emoji.png" alt @click="showEmotionFun" />
                <emtion v-show="showEmotion"></emtion>
                <!--截图-->
               <!-- <img @click="screenshot" src="./img/chat_screenshot.png" />  -->
                <img src="./img/chat_picture.png" alt />
                <input
                  type="file"
                  id="inputerf"
                  ref="chatPhoto"
                  @change="selectPhoto('chatImage','#inputerf')"
                />
               <!-- <img @click="screenshot" src="./img/chat_screenshot.png" />  -->
              </div>
              
              <div class="input_box" @click="closeEmotionFun">
                <!--输入框-->
                 <!-- <textarea
                  contenteditable
                  v-model="chatInput"
                  @input="chatInputFun"
                  @keydown="keyDownFun"
                  @click="changeCount"
                ></textarea> -->

                 <div v-if="ifIE" id="chatInput"
                  contenteditable="true"
                  @input="chatInputFun"
                  @keydown="keyDownFun"
                  ref="chatInput"
                  class="chatInput"
                ></div>
            
                <div v-else id="chatInput"
                  contenteditable="true"
                  @keydown="keyDownFun"
                  @propertychange="chatInputFun"
                  ref="chatInput"
                  class="chatInput"
                ></div>

               <!-- <editdiv
                  contenteditable="true"
                  v-model="chatInput"
                  @input="chatInputFun"
                  @keydown="keyDownFun"
                  @blur.prevent="changeCount"
                  ref="chatInput"
                  class="chatInput"
                //   @onpropertychange="chatInputFun"
                ></editdiv>  -->

                <ul class="atUserList" v-if="showrecomndList">
                  <li v-if="isAdministration" @click.stop="selectThis('all','所有人')">
                      <!--判断是否是管理-->
                      <img class="img" src="./img/chat_icon_all@2x.png" alt />
                      <span>所有人</span>
                  </li>
                  <li
                    v-for="v in recomndList"
                    :key="v.i"
                    @click.stop="selectThis(v.user_id,v.nick_name)"
                  >
                    <img :src="v.image_path" alt v-if="v.image_path" @error="getError" />
                    <img src="./img/me_img_default@2x.1.png" v-else />
                    <span>{{v.nick_name}}</span>
                  </li>
                </ul>
                <!-- <div class="btn" @click="closeBox" style="z-index:9998">关闭</div> -->
                <div class="btn sendBtn" @click="sendMsg">发送Eenter</div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="memberList">
          <div class="bothBox">
            <chatSite></chatSite>
            <memberList ref="memberList"></memberList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import chatSite from "./chatSite";
import memberList from "./memberList";
import emtion from "./emotions/emtion";
import bus from "@/tool/bus";
import editdiv  from './emotions/editdiv'
//import kscreenshot from 'kscreenshot'

var newList = [];
export default {
  components: {
    editdiv,
    memberList,
    chatSite,
    emtion,
    memberList,
    chatSite
  },
  provide(){
    return{
       reload:this.reload
    }
  },
  data() {
    return {
      tiren:false,
      outStatus:false,
      outStatus1:false,
      client_id: window.localStorage.getItem("username"),
      ImgArr:'',//判断复制的链接是否重复
      ispaseimgsrc:false,//是否复制了图片
       ImgArr1:'',///暂存图片
       ImgArrys:[],
       st:0,
      emotionName: [
        {
          name: "#[微笑]#",
          src: require("./emotions/emoji/weixiao.png"),
          nickname:'[困了]'
        },
        {
          name: "#[撇嘴]#",
          src: require("./emotions/emoji/piezui.png"),
          nickname:'[捂嘴]'
        },
        {
          name: "#[色]#",
          src: require("./emotions/emoji/se.png"),
          nickname:'[面无表情]'
        },
        {
          name: "#[发呆]#",
          src: require("./emotions/emoji/fadai.png"),
          nickname:'[乱七八糟]'
        },
        // {
        //   name: "#[得意]#",
        //   src: require("./emotions/emoji/deyi.png"),
        //   nickname:'[喜笑颜开]'
        // },
        // {
        //   name: "#[流泪]#",
        //   src: require("./emotions/emoji/liulei.png"),
        //   nickname:'[拥抱]'
        // },
        {
          name: "#[害羞]#",
          src: require("./emotions/emoji/haixiu.png"),
          nickname:'[吐舌]'
        },
        {
          name: "#[关嘴]#",
          src: require("./emotions/emoji/bizui.png"),
          nickname:'[喜极而泣]'
        },
        {
          name: "#[睡]#",
          src: require("./emotions/emoji/shui.png"),
          nickname:'[安静]'
        },
        {
          name: "#[大哭]#",
          src: require("./emotions/emoji/daku.png"),
          nickname:'[心动]'
        },
        {
          name: "#[尴尬]#",
          src: require("./emotions/emoji/ganga.png"),
          nickname:'[亲亲]'
        },
        {
          name: "#[发怒]#",
          src: require("./emotions/emoji/fanu.png"),
          nickname:'[无奈]'
        },
  
        {
          name: "#[调皮]#",
          src: require("./emotions/emoji/diaopi.png"),
          nickname:'[飞吻]'
        },
        {
          name: "#[呲牙]#",
          src: require("./emotions/emoji/ciya.png"),
          nickname:'[可爱]'
        },
        {
          name: "#[惊讶]#",
          src: require("./emotions/emoji/jingya.png"),
          nickname:'[困惑]'
        },
        {
          name: "#[难过]#",
          src: require("./emotions/emoji/nanguo.png"),
          nickname:'[思考]'
        },
        // {
        //   name: "#[酷]#",
        //   src: require("./emotions/emoji/ku.png"),
        //   nickname:'[光环]'
        // },
        {
          name: "#[冷汗]#",
          src: require("./emotions/emoji/lenghan.png"),
          nickname:'[悲伤]'
        },
        {
          name: "#[抓狂]#",
          src: require("./emotions/emoji/zhuakuang.png"),
          nickname:'[篮球]'
        },
        {
          name: "#[吐]#",
          src: require("./emotions/emoji/tu.png"),
          nickname:'[吃惊]'
        },
        {
          name: "#[偷笑]#",
          src: require("./emotions/emoji/touxiao.png"),
          nickname:'[痛苦]'
        },
        {
          name: "#[可爱]#",
          src: require("./emotions/emoji/keai.png"),
          nickname:'[失望]'
        },
        {
          name: "#[翻眼]#",
          src: require("./emotions/emoji/baiyan.png"),
          nickname:'[眯眼笑]'
        },
        {
          name: "#[傲慢]#",
          src: require("./emotions/emoji/aoman.png"),
          nickname:'[咧嘴笑]'
        },
        {
          name: "#[饥饿]#",
          src: require("./emotions/emoji/jie.png"),
          nickname:'[忧郁]'
        },
        {
          name: "#[困倦]#",
          src: require("./emotions/emoji/kun.png"),
          nickname:'[焦虑]'
        },
        {
          name: "#[惊恐]#",
          src: require("./emotions/emoji/jingkong.png"),
          nickname:'[担心]'
        },
        {
          name: "#[流汗]#",
          src: require("./emotions/emoji/liuhan.png"),
          nickname:'[流汗]'
        },
        {
          name: "#[憨笑]#",
          src: require("./emotions/emoji/hanxiao.png"),
          nickname:'[皮了]'
        },
        {
          name: "#[大兵]#",
          src: require("./emotions/emoji/dabing.png"),
          nickname:'[嘻嘻]'
        },
        {
          name: "#[奋斗]#",
          src: require("./emotions/emoji/fendou.png"),
          nickname:'[么么]'
        },
        {
          name: "#[咒骂]#",
          src: require("./emotions/emoji/zhouma.png"),
          nickname:'[足球]'
        },
        {
          name: "#[疑问]#",
          src: require("./emotions/emoji/yiwen.png"),
          nickname:'[便便]'
        },
        {
          name: "#[嘘]#",
          src: require("./emotions/emoji/xu.png"),
          nickname:'[闭嘴]'
        },
        {
          name: "#[晕]#",
          src: require("./emotions/emoji/yun.png"),
          nickname:'[见钱眼开]'
        },
        {
          name: "#[折磨]#",
          src: require("./emotions/emoji/zhemo.png"),
          nickname:'[强]'
        },
        {
          name: "#[衰]#",
          src: require("./emotions/emoji/shuai.png"),
          nickname:'[囧]'
        },
        {
          name: "#[骷髅]#",
          src: require("./emotions/emoji/kulou.png"),
          nickname:'[惧怕]'
        },
        {
          name: "#[敲打]#",
          src: require("./emotions/emoji/qiaoda.png"),
          nickname:'[嘘哦]'
        },
        {
          name: "#[再见]#",
          src: require("./emotions/emoji/zaijian.png"),
          nickname:'[牛仔]'
        },
        {
          name: "#[擦汗]#",
          src: require("./emotions/emoji/cahan.png"),
          nickname:'[大笑]'
        },
        {
          name: "#[抠鼻]#",
          src: require("./emotions/emoji/koubi.png"),
          nickname:'[眨眼]'
        },
        {
          name: "#[鼓掌]#",
          src: require("./emotions/emoji/guzhang.png"),
          nickname:'[饥渴]'
        },
        {
          name: "#[糗大了]#",
          src: require("./emotions/emoji/qiudale.png"),
          nickname:'[傻笑]'
        },
        // {
        //   name: "#[坏笑]#",
        //   src: require("./emotions/emoji/huaixiao.png"),
        //   nickname:'[眼冒金星]'
        // },
        {
          name: "#[左哼哼]#",
          src: require("./emotions/emoji/zuohengheng.png"),
          nickname:'[国旗]'
        },
        {
          name: "#[右哼哼]#",
          src: require("./emotions/emoji/youhengheng.png"),
          nickname:'[感冒]'
        },
        {
          name: "#[哈欠]#",
          src: require("./emotions/emoji/haqian.png"),
          nickname:'[生气]'
        },
        {
          name: "#[鄙视]#",
          src: require("./emotions/emoji/bishi.png"),
          nickname:'[怕怕]'
        },
        {
          name: "#[委屈]#",
          src: require("./emotions/emoji/weiqu.png"),
          nickname:'[睡了]'
        },
        {
          name: "#[快哭了]#",
          src: require("./emotions/emoji/kuaikule.png"),
          nickname:'[这是]'
        },
        {
          name: "#[阴险]#",
          src: require("./emotions/emoji/yinxian.png"),
          nickname:'[恶魔]'
        },
        {
          name: "#[亲亲]#",
          src: require("./emotions/emoji/qinqin.png"),
          nickname:'[白眼]'
        },
        {
          name: "#[吓]#",
          src: require("./emotions/emoji/xia.png"),
          nickname:'[晕啊]'
        },
        {
          name: "#[可怜]#",
          src: require("./emotions/emoji/kelian.png"),
          nickname:'[嫌弃]'
        }
      ],
    
      // emotionName: [
      //   {
      //     name: "#[微笑]#",
      //     src: require("./emotions/emoji/weixiao.png"),
      //     nickname: "[困]"
      //   },
      //   {
      //     name: "#[撇嘴]#",
      //     src: require("./emotions/emoji/piezui.png"),
      //     nickname: "[捂嘴]"
      //   },
      //   {
      //     name: "#[色]#",
      //     src: require("./emotions/emoji/se.png"),
      //     nickname: "[面无表情]"
      //   },
      //   {
      //     name: "#[发呆]#",
      //     src: require("./emotions/emoji/fadai.png"),
      //     nickname: "[乱七八糟]"
      //   },
      //   // {
      //   //   name: "#[得意]#",
      //   //   src: require("./emotions/emoji/deyi.png"),
      //   //   nickname: "[喜笑颜开]"
      //   // },
      //   // {
      //   //   name: "#[流泪]#",
      //   //   src: require("./emotions/emoji/liulei.png"),
      //   //   nickname: "[拥抱]"
      //   // },
      //   {
      //     name: "#[害羞]#",
      //     src: require("./emotions/emoji/haixiu.png"),
      //     nickname: "[吐舌]"
      //   },
      //   {
      //     name: "#[闭嘴]#",
      //     src: require("./emotions/emoji/bizui.png"),
      //     nickname: "[喜极而泣]"
      //   },
      //   {
      //     name: "#[睡]#",
      //     src: require("./emotions/emoji/shui.png"),
      //     nickname: "[安静]"
      //   },
      //   {
      //     name: "#[大哭]#",
      //     src: require("./emotions/emoji/daku.png"),
      //     nickname: "[心动]"
      //   },
      //   {
      //     name: "#[尴尬]#",
      //     src: require("./emotions/emoji/ganga.png"),
      //     nickname: "[亲亲]"
      //   },
      //   {
      //     name: "#[发怒]#",
      //     src: require("./emotions/emoji/fanu.png"),
      //     nickname: "[无奈]"
      //   },
      //   {
      //     name: "#[调皮]#",
      //     src: require("./emotions/emoji/diaopi.png"),
      //     nickname: "[飞吻]"
      //   },
      //   {
      //     name: "#[呲牙]#",
      //     src: require("./emotions/emoji/ciya.png"),
      //     nickname: "[可爱]"
      //   },
      //   {
      //     name: "#[惊讶]#",
      //     src: require("./emotions/emoji/jingya.png"),
      //     nickname: "[困惑]"
      //   },
      //   {
      //     name: "#[难过]#",
      //     src: require("./emotions/emoji/nanguo.png"),
      //     nickname: "[思考]"
      //   },
      //   // {
      //   //   name: "#[酷]#",
      //   //   src: require("./emotions/emoji/ku.png"),
      //   //   nickname: "[光环]"
      //   // },
      //   {
      //     name: "#[冷汗]#",
      //     src: require("./emotions/emoji/lenghan.png"),
      //     nickname: "[悲伤]"
      //   },
      //   {
      //     name: "#[抓狂]#",
      //     src: require("./emotions/emoji/zhuakuang.png"),
      //     nickname: "[篮球]"
      //   },
      //   {
      //     name: "#[吐]#",
      //     src: require("./emotions/emoji/tu.png"),
      //     nickname: "[惊讶]"
      //   },
      //   {
      //     name: "#[偷笑]#",
      //     src: require("./emotions/emoji/touxiao.png"),
      //     nickname: "[痛苦]"
      //   },
      //   {
      //     name: "#[可爱]#",
      //     src: require("./emotions/emoji/keai.png"),
      //     nickname: "[失望]"
      //   },
      //   {
      //     name: "#[白眼]#",
      //     src: require("./emotions/emoji/baiyan.png"),
      //     nickname: "[眯眼笑]"
      //   },
      //   {
      //     name: "#[傲慢]#",
      //     src: require("./emotions/emoji/aoman.png"),
      //     nickname: "[咧嘴笑]"
      //   },
      //   {
      //     name: "#[饥饿]#",
      //     src: require("./emotions/emoji/jie.png"),
      //     nickname: "[忧郁]"
      //   },
      //   {
      //     name: "#[困]#",
      //     src: require("./emotions/emoji/kun.png"),
      //     nickname: "[焦虑]"
      //   },
      //   {
      //     name: "#[惊恐]#",
      //     src: require("./emotions/emoji/jingkong.png"),
      //     nickname: "[担心]"
      //   },
      //   {
      //     name: "#[流汗]#",
      //     src: require("./emotions/emoji/liuhan.png"),
      //     nickname: "[流汗]"
      //   },
      //   {
      //     name: "#[憨笑]#",
      //     src: require("./emotions/emoji/hanxiao.png"),
      //     nickname: "[调皮]"
      //   },
      //   {
      //     name: "#[大兵]#",
      //     src: require("./emotions/emoji/dabing.png"),
      //     nickname: "[嘻嘻]"
      //   },
      //   {
      //     name: "#[奋斗]#",
      //     src: require("./emotions/emoji/fendou.png"),
      //     nickname: "[么么]"
      //   },
      //   {
      //     name: "#[咒骂]#",
      //     src: require("./emotions/emoji/zhouma.png"),
      //     nickname: "[足球]"
      //   },
      //   {
      //     name: "#[疑问]#",
      //     src: require("./emotions/emoji/yiwen.png"),
      //     nickname: "[便便]"
      //   },
      //   {
      //     name: "#[嘘]#",
      //     src: require("./emotions/emoji/xu.png"),
      //     nickname: "[闭嘴]"
      //   },
      //   {
      //     name: "#[晕]#",
      //     src: require("./emotions/emoji/yun.png"),
      //     nickname: "[见钱眼开]"
      //   },
      //   {
      //     name: "#[折磨]#",
      //     src: require("./emotions/emoji/zhemo.png"),
      //     nickname: "[强]"
      //   },
      //   {
      //     name: "#[衰]#",
      //     src: require("./emotions/emoji/shuai.png"),
      //     nickname: "[囧]"
      //   },
      //   {
      //     name: "#[骷髅]#",
      //     src: require("./emotions/emoji/kulou.png"),
      //     nickname: "[惧怕]"
      //   },
      //   {
      //     name: "#[敲打]#",
      //     src: require("./emotions/emoji/qiaoda.png"),
      //     nickname: "[嘘]"
      //   },
      //   {
      //     name: "#[再见]#",
      //     src: require("./emotions/emoji/zaijian.png"),
      //     nickname: "[牛仔]"
      //   },
      //   {
      //     name: "#[擦汗]#",
      //     src: require("./emotions/emoji/cahan.png"),
      //     nickname: "[大笑]"
      //   },
      //   {
      //     name: "#[抠鼻]#",
      //     src: require("./emotions/emoji/koubi.png"),
      //     nickname: "[眨眼]"
      //   },
      //   {
      //     name: "#[鼓掌]#",
      //     src: require("./emotions/emoji/guzhang.png"),
      //     nickname: "[饥饿]"
      //   },
      //   {
      //     name: "#[糗大了]#",
      //     src: require("./emotions/emoji/qiudale.png"),
      //     nickname: "[傻笑]"
      //   },
      //   // {
      //   //   name: "#[坏笑]#",
      //   //   src: require("./emotions/emoji/huaixiao.png"),
      //   //   nickname: "[眼冒金星]"
      //   // },
      //   {
      //     name: "#[左哼哼]#",
      //     src: require("./emotions/emoji/zuohengheng.png"),
      //     nickname: "[国旗]"
      //   },
      //   {
      //     name: "#[右哼哼]#",
      //     src: require("./emotions/emoji/youhengheng.png"),
      //     nickname: "[感冒]"
      //   },
      //   {
      //     name: "#[哈欠]#",
      //     src: require("./emotions/emoji/haqian.png"),
      //     nickname: "[生气]"
      //   },
      //   {
      //     name: "#[鄙视]#",
      //     src: require("./emotions/emoji/bishi.png"),
      //     nickname: "[冷汗]"
      //   },
      //   {
      //     name: "#[委屈]#",
      //     src: require("./emotions/emoji/weiqu.png"),
      //     nickname: "[睡了]"
      //   },
      //   {
      //     name: "#[快哭了]#",
      //     src: require("./emotions/emoji/kuaikule.png"),
      //     nickname: "[惊恐]"
      //   },
      //   {
      //     name: "#[阴险]#",
      //     src: require("./emotions/emoji/yinxian.png"),
      //     nickname: "[恶魔]"
      //   },
      //   {
      //     name: "#[亲亲]#",
      //     src: require("./emotions/emoji/qinqin.png"),
      //     nickname: "[白眼]"
      //   },
      //   {
      //     name: "#[吓]#",
      //     src: require("./emotions/emoji/xia.png"),
      //     nickname: "[晕]"
      //   },
      //   {
      //     name: "#[可怜]#",
      //     src: require("./emotions/emoji/kelian.png"),
      //     nickname: "[嫌弃]"
      //   }
      // ],
      atTip: false, //显示被@
      duankailianjie: false, //WebSocket 连接状态
      tableData: [], //聊天内容
      Forbidden: true, //禁言
      Kickout: true, //踢出群聊
      isLoading: true, //显示链接中
      isTop: true, //
      beAtUserId: "", //用户id
      magnify: false, //遮罩层
      showrecomndList: false, //艾特列表
      showEmotion: false, //显示表情列表
      chatInput: "", //输入框的内容
      recomndList: [], //艾特列表的数据
      myid: window.localStorage.getItem("uid"),
      chatcontent: "", //转换给后台的内容
      chatContent: [], //边发边存的数组
      searchName: "", //搜索名字
      isAdministration: false, //是否是管理
      out_room: "", //0为未踢出1为踢出3为永久退出
      path: "ws://lts.tyzkf8.com:8284",
      timeoutObj:'',
      timeout:20000,
      contenTotal:0, //总的聊天条数
      tempTotal:0,
      More:false,
      scrollBottomSwitch:false,
      kaiguan:true,
      page:1,
    onoSlef:false,
    scrollHeight:0,//当前的高
    isOne:true,
    rightclickShow:false,
    UserId: "",//用户ID
    connt:0,//踢人类型传的值
    outstring:'',//踢人类型
    valuE:"",//踢出时间
    isonecf:0,//是否第一次点击查看更多
    Administrators:window.localStorage.getItem('Admin'),//是否是管理员  1是管理员 0不是
    ifIE:true,//不是ie
    timeFF:'',//查询历史记录传给后台的值
    inject: ['reload'],
    isRouterAlive:true,//判断是否重新加载组件
    ispaste:false,//是否截图
    };
  },
  mounted() {
    this.init();
    // this.Kscreen();
     this.paseImg();
     if (!!window.ActiveXObject || "ActiveXObject" in window) {// ie
       this.ifIE = false;
       this.$refs.chatInput.addEventListener('DOMNodeInserted', this.chatInputFun, false);
       this.$refs.chatInput.addEventListener('DOMNodeRemoved', this.chatInputFun, false);
       this.$refs.chatInput.addEventListener('DOMCharacterDataModified', this.chatInputFun, false);
    //document.getElementById('chatInput').onpropertychange=this.chatInputFun()
    } else { 
      this.ifIE=true
      
    }
    setInterval(() => {
             this.start()
          }, 20000) 
    this.scrollBottom();
    bus.$on("EmotionsFun", this.myemotionFun);
    bus.$on("atThisUserFun", this.atThisUser);
    bus.$on("AtThisUser", this.AtThisUser);
    bus.$on("confige",( index,val, useid)=>{
     
       this.UserId=useid
       this.valuE=val;
      this.confige(index, val)
    });
    this. getChatHistory();
  },
  // updated: function() {
  //   if (this.isTop) {
  //     this.$nextTick(function() {
  //       var div = document.getElementById("dialogue_box");
  //       if (div) {
  //         div.scrollTop = div.scrollHeight;
  //       }
  //     });
  //   }
  // },
  methods: {
     reload(){
    
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    },
    confire(){
    this.outStatus = false;
    this.outStatus1=true;
    },
    changeCount(){
      if(/@/.test(this.chatInput)){
    
      }else{
       this.showrecomndList = false;
      }
    },
    //
    getError() {
      var img = event.srcElement;
      img.src = require("./img/me_img_default@2x.1.png"); //替换的图片
      img.onerror = null; //控制不要一直触发错误
    },
    getSrc(name) {
      for (const emotion of this.emotionName) {
        if (emotion.name === name) {
          return emotion.src;
        }
      }
    },
    //截图的引入
    Kscreen(){
       var that=this;
      
 this.ks=   new kscreenshot(
    {
        key: 65 ,
        needDownload:false,
       // immediately:true,
        copyPath(e){
     },
     endCB(e)
     {

     
        that.axios({
        method: "post",
        url: that.imgSrc + "api/user/uploadScreenshot",
         data: {
          token: window.localStorage.getItem("token"),
            base64str:e
        }
        
      }).then(res => {
        if (res.data.code == 0)
      {
        that.ImgArr=res.data.data
        that.ImgArrys.push(res.data.data)
         let chatInputImg = document.createElement("img");
      chatInputImg.classList.add('chatPhoto1')
      chatInputImg.style.display = "inline";
      chatInputImg.src = res.data.data;
      var  msg = "<img src='"+res.data.data+"' style='max-width:60%;max-height:250px;'/>";
       // let inputAppendImg = that.$refs.chatInput.appendChild(msg); 
       that.ispaste=true
         $('#chatInput').append(msg); 
        }else{
          that.store.commit("hintMsg", "网络问题！");
          that.store.commit("hintShow", 1500);
        }
          

      })
    
     },
     cancelCB(){
        that.ImgArr=''
        that.ImgArrys=[];
        that.ispaste=false
      that.reload();
     }
    },)

    },
    getName(nickname) {
      var array = [];
      this.emotionName.forEach(v => {
        array.push(v.nickname);
        //array.push(v.src)
      });
      if (array.indexOf(nickname) != -1) {
        for (const emotion of this.emotionName) {
          if (emotion.nickname === nickname) {
            return emotion.name;
          }
        }
      } else {
        return nickname;
      }
    },
    closeEmotionFun() {
      this.showEmotion = false;
    },
    scrollBottom() {
      this.$nextTick(function() {
        setTimeout(()=>{
          var div = document.getElementById("dialogue_box");
          div.scrollTop = div.scrollHeight;
        
        },200)
      });
    },
 bigPhoto(url) {
      this.magnify = true;
      this.currentSrc = url;
      this.isTop = false;
    },
    getChatHistory() {
      //获取历史消息
      this.axios({
        method: "post",
        url: this.chatUrl + "api/user/getHistoryList",
        data: {
          token: window.localStorage.getItem("token"),
          page:this.page,
        end_time:this.timeFF
        }
      }).then(res => {
          
        if (res.data.code == 0) {
          if (res.data.data.chat_list.data && res.data.data.chat_list.data.length != 0) {
             this.contenTotal=res.data.data.chat_list.total;
             var div = document.getElementById("dialogue_box");
                  if (div) {
                    this.scrollHeight=div.scrollHeight;
                  }
            res.data.data.chat_list.data.forEach(v => {
              v.create_time = this.formatTime(v.create_time * 1000);
              if (v.content) {
                var faces = v.content.match(/#\[[\s\S]*?\]#/g);
                v.content = "<div><span>" + v.content;
                if (faces) {
                  faces.forEach(
                    faceVal =>
                      (v.content = v.content.replace(
                        faceVal,
                        `</span><img style="width:2rem" src="${this.getSrc(
                          faceVal
                        )}"/><span>`
                      ))
                  );
                  v.content += "</span></div>";
                  v.content = v.content.replace(/<p><\/p>/g, "");
                }
              } else {
                if (v.face) {
                  this.emotionName.forEach(value => {
                    if (v.face == value.name) {
                      v.face = value.src;
                    }
                  });
                }
              }
              this.tableData.unshift(v);
          this.page = parseInt(res.data.data.chat_list.current_page)+1;
              
              this.tempTotal=this.tableData.length
              if(this.tempTotal< this.contenTotal)
              {
                this.More=true
              }else{
                this.More=false
              }
            });
            
             if(this.kaiguan)
             {
             this.$nextTick(function() {
                  setTimeout(()=>{
                  if (div) {
                    div.scrollTop = div.scrollHeight+100;
                   
                    this.kaiguan = false;
                  }
                  },500)
                  
                });
             }
          }
        }
      });
    },
    init() {
      //初始化WebSocket
      if (typeof WebSocket === "undefine") {
        console.log("您的浏览器不支持websocket");
      } else {
        //实例化
        //实例化socket
        this.socket = new WebSocket(this.path);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
        // 关闭连接
        this.socket.onclose = this.close;
      }
    },
    canceL(){//取消禁言
       this.tiren=false;
    },
    open() {
      console.log("websocket连接成功");
      var login_data = {
        type: "login",
        client_name: window.localStorage.getItem("username"),
        room_id: 1,
        token: window.localStorage.getItem("token")
      };
      this.send(login_data);
    },
    // 消息发送之后重新计算心跳检测时间
    reset(){
      console.log('重新检测');   
       clearTimeout(this.timeoutObj)
       this.start()
    },
    // 用户登录状态,隔20秒重连一次
    start(){
      console.log('20秒的心跳重连');
      var that = this
      this.timeoutObj=setTimeout(function(){
       that.socket.send(JSON.stringify({
        type: "pong",
        client_name: window.localStorage.getItem("username"),
        room_id: 1,
        token: window.localStorage.getItem("token")
        }))
      },this.timeout)
    },
    error() {
      console.log("连接错误");
      this.store.commit("hintMsg", "网络出小差了，请耐心等待");
      this.store.commit("hintShow", 1000);
    },
    //
    getMessage(msg) {
      var conent = JSON.parse(msg.data);
      if (conent.type == "login") {
      this.timeFF=Date.parse(new Date().toString().slice(0,10))
        //链接成功
        this.isLoading = false;
        this.isLogin = true;
        this.total_count = conent.total;
        if(conent.chat_admin==1){
          this.isAdministration=true;
        }else {
          this.isAdministration=false;
        }
        this.chatContent.push({
          name: conent.nick_name,
           time: conent.time.substring(10,16),
           //time:this.formatTime(this.formateTime(conent.time * 1000)),
           //.
          type: "login_name"
        });
        // 
         
      }
     
      if (conent.type == "banned_admin") {//禁言类型
            this.chatContent.push({
            name: conent.banned_name,
            bannedtime: conent.banned_time,
             time: conent.time.substring(10,16),
             //time:this.formatTime(this.formateTime(conent.time * 1000)),
            banned_id:conent.banned_id,
            type: "banned"
          });
       
      }

 if (conent.type == "banned") {//禁言类型
          if(conent.content)
          {
          this.store.commit("hintMsg", conent.content);
          this.store.commit("hintShow", 3000);
          }
       
      }

      if (conent.type == "out_room") {//踢人类型
        this.chatContent.push({
          name: conent.out_name,
          out_nametime: conent.out_time,
            time: conent.time.substring(10,16),
           //time: this.formatTime(conent.time),
         // time:this.formatTime(this.formateTime(conent.time * 1000)),
          out_room_id:conent.out_room_id,
          type: "out_status"
        });
     
        if(this.myid==conent.out_room_id){
          
            this.outStatus = true;
            //手动断开
            this.close();
        }
      }

      if (conent.type == "say") {
        //聊天内容
        this.isTop = true;
        if (conent.content) {
          var faces = conent.content.match(/#\[[\s\S]*?\]#/g);
          conent.content += "<div><span>";
          if (faces) {
            faces.forEach(
              faceVal =>
                (conent.content = conent.content.replace(
                  faceVal,
                  `</span><img style="width:2rem" src="${this.getSrc(
                    faceVal
                  )}"/><span>`
                ))
            );
            conent.content += "</span></div>";
            conent.content = conent.content.replace(/<p><\/p>/g, "");
          }
          this.chatContent.push({
            client_id: conent.from_client_name,
            from_client_id: conent.from_client_id,
            conent: conent.content,
            face: "",
            pic: conent.pic,
            userId: conent.from_user_id,
            img: conent.image_path,
            name: conent.nick_name,
            login_level:conent.login_level,
            time: this.formatTime(conent.time),
            chat_admin:conent.chat_admin
          });
        
        } else if (conent.face) {
          this.emotionName.forEach(v => {
            if (conent.face == v.name) {
              this.chatContent.push({
                client_id: conent.from_client_name,
                from_client_id: conent.from_client_id,
                conent: conent.content,
                face: v.src,
                pic: conent.pic,
                userId: conent.from_user_id,
                img: conent.image_path,
                name: conent.nick_name,
                login_level:conent.login_level,
                time: this.formatTime(conent.time),
                chat_admin:conent.chat_admin
              });
            }
          });
        } else {
          this.chatContent.push({
            client_id: conent.from_client_name,
            from_client_id: conent.from_client_id,
            conent: conent.content,
            face: "",
            pic: conent.pic,
            userId: conent.from_user_id,
            img: conent.image_path,
            name: conent.nick_name,
            time: this.formatTime(conent.time),
            login_level:conent.login_level,
            chat_admin:conent.chat_admin
          });
        }

        window.localStorage.setItem(
          "chatContent",
          JSON.stringify(this.chatContent)
        );
      }
      if (conent.type == "at") {
        this.atTip = true;
        this.atName = conent.from_client_name;
      }
      if (conent.type == "logout") {
        this.total_count = conent.total;
      }
      
      if(this.isonecf==0)
      {
         this.scrollBottom();
      }
      
    },

    close(msg) {
      console.log("socket已经关闭");
      this.duankailianjie = true;
      this.isLoading = false;
    },
    formatTime(data) {
      var time = new Date(data);
      var year = Number(time.getFullYear());
      var month = Number(time.getMonth()) + 1;
      var date = Number(time.getDate());
      var hours = time
        .getHours()
        .toString()
        .padStart(2, "0");
      var minutes = time
        .getMinutes()
        .toString()
        .padStart(2, "0");
      /*if (minutes < 10) {
        minutes = "0" + minutes;
      }*/
      var time = hours + ":" + minutes;
      return time;
    },
    chatInputFun(e) {
     
      // 判断@ 出现艾特的列表
     // console.log(this.chatInput)
      // if(/@$/.test(this.chatInput)) {
      //   this.getChatUserList();
      //   this.showrecomndList = true;
      // }
    // 
      //  if(e.inputType === 'deleteContentBackward'){
      //   return
      // } else
 this.rightclickShow=false

//   var re=/<[^>]+>/g;
//       var str=e.target.innerHTML;
//       console.log('888=',e.target.innerHTML)
// var str=str.replace(re,"");
// console.log('777=',str)
 this.chatInput=e.target

 //console.log(e.target.innerHTML)
      //  if(this.$refs.chatInput.childNodes.length!=0){
      //    console.log(111111)
      //   e.target.innerHTML=""
      // }
      // if(e.target.innerHTML=="<p><br></p><p><br></p>")
      // {
      //  console.log(22222)
      //    e.target.innerHTML=""
      // }
      //  if(e.target.innerHTML=="<p><br></p>")
      // {
      //   console.log(33333)
      //    e.target.innerHTML=""
         
      // }
      // if(e.target.innerHTML=="<p></p><p></p>")
      // {
      //   console.log(4444)
      //    e.target.innerHTML=""
         
      // }
      this.chatInput=e.target.textContent
      var a=document.getElementById('chatInput').innerHTML
var regex2 = /\[(.+?)\]/g;

if(a.match(regex2))
{
  
 if( a.match(regex2)[0]=='[困了]'|| a.match(regex2)[0]=='[捂嘴]'||a.match(regex2)[0]=='[面无表情]'||a.match(regex2)[0]=='[乱七八糟]'||a.match(regex2)[0]=='[吐舌]'||a.match(regex2)[0]=='[喜极而泣]'||
   a.match(regex2)[0]=='[安静]' ||a.match(regex2)[0]=='[吐舌]' ||a.match(regex2)[0]=='[心动]' ||a.match(regex2)[0]=='[亲亲]' ||a.match(regex2)[0]=='[无奈]' ||a.match(regex2)[0]=='[飞吻]'
 ||a.match(regex2)[0]=='[可爱]'  ||a.match(regex2)[0]=='[困惑]'  ||a.match(regex2)[0]=='[思考]'  ||a.match(regex2)[0]=='[光环]'  ||a.match(regex2)[0]=='[悲伤]' ||a.match(regex2)[0]=='[篮球]'
  ||a.match(regex2)[0]=='[吃惊]'  ||a.match(regex2)[0]=='[痛苦]'  ||a.match(regex2)[0]=='[失望]'  ||a.match(regex2)[0]=='[眯眼笑]' ||a.match(regex2)[0]=='[咧嘴笑]' ||a.match(regex2)[0]=='[忧郁]'
 ||a.match(regex2)[0]=='[焦虑]' ||a.match(regex2)[0]=='[担心]' ||a.match(regex2)[0]=='[流汗]' ||a.match(regex2)[0]=='[皮了]' ||a.match(regex2)[0]=='[嘻嘻]'||a.match(regex2)[0]=='[么么]'
 ||a.match(regex2)[0]=='[足球]'||a.match(regex2)[0]=='[便便]'||a.match(regex2)[0]=='[闭嘴]'||a.match(regex2)[0]=='[见钱眼开]'||a.match(regex2)[0]=='[强]'||a.match(regex2)[0]=='[囧]'
 ||a.match(regex2)[0]=='[惧怕]' ||a.match(regex2)[0]=='[嘘哦]' ||a.match(regex2)[0]=='[牛仔]'||a.match(regex2)[0]=='[大笑]'||a.match(regex2)[0]=='[眨眼]'||a.match(regex2)[0]=='[傻笑]'
 ||a.match(regex2)[0]=='[国旗]' ||a.match(regex2)[0]=='[感冒]' ||a.match(regex2)[0]=='[生气]'||a.match(regex2)[0]=='[怕怕]'||a.match(regex2)[0]=='[睡了]'||a.match(regex2)[0]=='[这是]'
||a.match(regex2)[0]=='[白眼]' ||a.match(regex2)[0]=='[晕啊]'||a.match(regex2)[0]=='[嫌弃]' )
      for (let v = 0; v < this.emotionName.length; v++) {
      if (a.match(regex2)[0] == this.emotionName[v].nickname) {
      let chatInputImg = document.createElement("img");
      chatInputImg.style.width = 20 + "px";
      chatInputImg.style.height = 20 + "px";
      chatInputImg.style.display = "inline";
      chatInputImg.src = this.emotionName[v].src; 
      var stppp= a.match(regex2)[0].replace(/\[|]/g,'')
      document.getElementById('chatInput').innerHTML=document.getElementById('chatInput').innerHTML.replace(/\[.*?\]/g,'').split(stppp).join("");
      let inputAppendImg = this.$refs.chatInput.appendChild(chatInputImg);
            }
          }
 }
      var tt=0
       if(/<span\s*[^>]*>(.*?)<\/span>/ig.test(a))
       {
           tt=1
       }
     a= a.replace(/<span\s*[^>]*>(.*?)<\/span>/ig,"$1");
   // document.getElementById('chatInput').innerHTML=document.getElementById('chatInput').innerHTML.replace(/<\/?.+?>/g,"").replace(/&nbsp;/ig, "")
  if(tt==1)
  {
     document.getElementById('chatInput').innerHTML=a;
  }
       if(e.target.innerHTML==="<div><br></div><div><br></div>"){
        e.target.innerHTML=""
      }
      if(/@$/.test( this.chatInput)){
        this.getChatUserList();
        this.showrecomndList = true;
      }else if(/@/.test( this.chatInput)){
        this.getChatUserList();
      } else{
        this.showrecomndList = false;
      }
    },
    send(params) {
      this.socket.send(JSON.stringify(params));
    },
    //enter
    keyDownFun(event) {
      this.showEmotion = false;
      //this.rightclickShow=false;
      if(event.keyCode=='8')
      {
        return;
      }
     
      if (event.keyCode == "13") {
         this.sendMsg();
        //阻止换行
         event.cancelBubble=true;
         event.preventDefault();
         event.stopPropagation();
        
        
      
        // //enter 发送
        // event.preventDefault();
        // if (/^[ ]*$/.test(this.chatInput)) {
        //   this.store.commit("hintMsg", "不能发送空白消息");
        //   this.store.commit("hintShow", 1500);
        // } else {
        //   var faces = this.chatInput.match(/\[[\s\S]*?\]/g);
        //   if (faces) {
        //     faces.forEach(
        //       faceVal =>
        //         (this.chatInput = this.chatInput.replace(
        //           faceVal,
        //           this.getName(faceVal)
        //         ))
        //     );
        //   }
        //   this.chatcontent = this.chatInput;
        //   var obj = {
        //     type: "say",
        //     to_client_id: "all",
        //     room_id: 1,
        //     content: this.chatcontent,
        //     at_user_id: this.beAtUserId,
        //     face: "",
        //     pic: "",
        //     time: new Date().getTime()
        //   };
        //   this.send(obj);
        // }
        // this.chatInput = "";
        // this.beAtUserId = "";

      }
    },

    showEmotionFun() {
      //显示表情列表
      this.showEmotion = !this.showEmotion;
      //console.log(this.showEmotion)
    },

    //发送x
    sendMsg() {
      let chatInputElement=this.$refs.chatInput.childNodes
       //let chatInputElement = this.chatInput
      let chatInputData = [];
      for (let i = 0; i < chatInputElement.length; i++) {
        if (chatInputElement[i].data) {
          chatInputData.push(chatInputElement[i].data);
        } else if (
          chatInputElement[i].src ===
          this.imgSrc+"static/img/deyi.79dbeea.png"
        ) {
          chatInputData.push("[喜笑颜开]");
        } else if (
          chatInputElement[i].src ===
          this.imgSrc+"static/img/liulei.6c070bb.png"
        ) {
          chatInputData.push("[拥抱]");
        } else if (
          chatInputElement[i].src ===
          this.imgSrc+"static/img/ku.00555ac.png"
        ) {
          chatInputData.push("[光环]");
        } else if (
          chatInputElement[i].src ===
          this.imgSrc+"static/img/huaixiao.c28cda7.png"
        ) {
          chatInputData.push("[眼冒金星]");
        } else {
          for (let v = 0; v < this.emotionName.length; v++) {
            if (chatInputElement[i].src === this.emotionName[v].src) {
               chatInputData.push(this.emotionName[v].nickname);
            }
          }
         }
      }
       let chatInputDataStr = chatInputData.join("");
//      console.log(chatInputData)
//      let stTRRR=document.getElementById('chatInput').innerHTML
//  let stTRRR1=stTRRR.replace(/<\/?.+?>/g,"")
//    this.chatInput =stTRRR1.replace(/&nbsp;/ig, "")
//       console.log(stTRRR)
//     let ish=/<\/?.+?>/g.test(stTRRR)
//      var  reg = /<[^>]+>/g;
//     console.log(ish)
//   //  if( this.chatInput && ish)
//   //  {
//   //    chatInputData.push(this.chatInput)
//   //  }
//    let chatInputDataStr = chatInputData.join("");
//     // console.log(this.chatInput)
   
//     // console.log(chatInputDataStr,999)
//    if(chatInputDataStr)
//    {
//        this.chatInput =chatInputDataStr ;
//    }else{
//        this.chatInput =this.chatInput+ chatInputDataStr ;
//    }
   
   

    this.chatInput =chatInputDataStr ;
      this.showEmotion = false; //隐藏表情列表
    
      if(!this.$refs.chatInput.innerHTML)
      {
       this.ispaste=false
      }
    
 if(this.ispaste ){
     
     if(this.ImgArr)
     {
     
  this.ImgArrys.forEach((v,i)=>{
    
     var obj = {
              type: "say",
              to_client_id: "all",
              room_id: 1,
              content: "",
              face: "",
              pic: v,
              time: new Date().getTime()
            };
     this.send(obj);
  })

           
               this.ispaste ="";
               this.ImgArr="";
               this.ImgArrys=[];
     }
          
            if(!/^[ ]*$/.test(this.chatInput))
            {
                 var faces = this.chatInput.match(/\[[\s\S]*?\]/g);
        if (faces) {
          faces.forEach(faceVal => {
            this.chatInput = this.chatInput.replace(
              faceVal,
              this.getName(faceVal)
            );
          });
        }
       this.reset()
        this.chatcontent = this.chatInput;
        var obj = {
          type: "say",
          to_client_id: "all",
          room_id: 1,
          content: this.chatcontent,
          at_user_id: this.beAtUserId,
          face: "",
          pic: "",
          time: new Date().getTime() 
        };
        this.send(obj);
            }

      }else{
      if (/^[ ]*$/.test(this.chatInput)) {
        this.store.commit("hintMsg", "不能发送空白消息");
        this.store.commit("hintShow", 1500);
      } else {
        var faces = this.chatInput.match(/\[[\s\S]*?\]/g);
        if (faces) {
          faces.forEach(faceVal => {
            this.chatInput = this.chatInput.replace(
              faceVal,
              this.getName(faceVal)
            );
          });
        }
       this.reset()
        this.chatcontent = this.chatInput;
        var obj = {
          type: "say",
          to_client_id: "all",
          room_id: 1,
          content: this.chatcontent,
          at_user_id: this.beAtUserId,
          face: "",
          pic: "",
          time: new Date().getTime() 
        };
        this.send(obj);
      }
      }
      // if (/^[ ]*$/.test(this.chatInput)) {
      //   this.store.commit("hintMsg", "不能发送空白消息");
      //   this.store.commit("hintShow", 1500);
      // } else {
      //   var faces = this.chatInput.match(/\[[\s\S]*?\]/g);
      //   if (faces) {
      //     faces.forEach(faceVal => {
      //       this.chatInput = this.chatInput.replace(
      //         faceVal,
      //         this.getName(faceVal)
      //       );
      //     });
      //   }
      //  this.reset()
      //   this.chatcontent = this.chatInput;
      //   var obj = {
      //     type: "say",
      //     to_client_id: "all",
      //     room_id: 1,
      //     content: this.chatcontent,
      //     at_user_id: this.beAtUserId,
      //     face: "",
      //     pic: "",
      //     time: new Date().getTime() 
      //   };
      //   this.send(obj);
      // }
      this.chatInput = "";
      this.beAtUserId = "";
      this.$refs.chatInput.innerHTML=''
      document.getElementById('chatInput').innerHTML="";
      this.scrollBottom();
     this.ImgArr1='';
     this.st=0;
      this.ImgArrys=[];
    },
    closeAt() {
      // 关闭显示@
      this.atTip = false;
    },
    // 选择艾特的人
    selectThis(val, name) {
      var newVal = "," + val;
      if (this.beAtUserId == "") {
        this.beAtUserId = val;
      } else {
        this.beAtUserId += newVal;
      }
      // this.chatInput+=this.beAtUserId
      var stR = this.$refs.chatInput.innerHTML;
     var n=(stR.split('@')).length-1;
      var index = stR.lastIndexOf("@");
      stR = stR.substring(0,index+1);
      // this.chatInput += this.chatInput.substring(0,index-1)+'@' + name;
      // this.$refs.chatInput.innerHTML=this.chatInput.substring(0,index+1) + name
      // this.chatInput=this.$refs.chatInput.innerHTML
      //console.log(this.chatInput)
       //this.chatInput = name;
      //  console.log(this.chatInput)
    //  if(n>1){
    //      this.$refs.chatInput.innerHTML="&nbsp"+stR +'&nbsp'+ name + "&nbsp"
    //  }else{
    //     this.$refs.chatInput.innerHTML=stR+ name + "&nbsp"
    //  }
     this.$refs.chatInput.innerHTML=stR+ name + "&nbsp"
        //this.$refs.chatInput.innerHTML+=name
      this.showrecomndList = false;
      this.Focus();
    },
    getChatUserList() {
      //获取@ 用户列表
      this.axios({
        method: "post",
        url: this.chatUrl + "api/user/getChatUserList",
        data: {
          token: window.localStorage.getItem("token"),
          search: this.searchName
        }
      }).then(res => {
        if (res.data.code == 0) {
        this.recomndList=res.data.data; 
        var stR = this.chatInput;
        var index = stR.lastIndexOf("@");
        stR = stR.substring(index + 1, stR.length);
        newList = this.recomndList.filter(item => {
        if (item.nick_name.includes(stR)) {
          return item;
        }
      });
      this.recomndList = newList;
      return newList;
        }else{
          this.showrecomndList = false;
        }
      });
    },

    //发送图片
    selectPhoto(which, inputer) {
      if (!/image\/\w+/.test($(inputer)[0].files[0].type)) {
        this.store.commit("hintMsg", "请上传图片");
        this.store.commit("hintShow", 1000);
      } else {
        var formData = new FormData();
        formData.append("token", window.localStorage.getItem("token"));
        formData.append("name", which);
        formData.append(which, $(inputer)[0].files[0]);
        this.axios({
          method: "post",
          url: this.imgSrc+ "/api/user/uploadImg",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }).then(res => {
          
          if (res.data.code == 0) {
            var obj = {
              type: "say",
              to_client_id: "all",
              room_id: 1,
              content: "",
              face: "",
              pic: res.data.data,
              time: new Date().getTime()
            };
            this.send(obj);
            this.scrollBottom();
          } else {
            this.store.commit("hintMsg", res.data.msg);
            this.store.commit("hintShow", 1500);
          }
        });
      }
    },

    myemotionFun(name, src, nickname) {
      // this.chatInput = this.chatInput + nickname;
      // this.showEmotion = false;
      this.showEmotion = false;
      let chatInputImg = document.createElement("img");
      chatInputImg.style.width = 20 + "px";
      chatInputImg.style.height = 20 + "px";
      chatInputImg.style.display = "inline";
      chatInputImg.src = src;
      let inputAppendImg = this.$refs.chatInput.appendChild(chatInputImg);
      this.Focus()
    },
//点击头像艾特
    atThisUser(val, name) {
      var newVal = "," + val;
      if (this.beAtUserId == "") {
        this.beAtUserId = val;
      } else {
        this.beAtUserId += newVal;
      }
      this.$refs.chatInput.innerHTML+= "&nbsp"+"@" + name + "&nbsp";
       //this.$refs.chatInput.focus();
       this.Focus()
      //this.$refs.chatInput.innerHTML+="@" + name;
    },

    //点击头像艾特
    AtThisUser(val, name) {
      var newVal = "," + val;
      if (this.beAtUserId == "") {
        this.beAtUserId = val;
      } else {
        this.beAtUserId += newVal;
      }
       this.$refs.chatInput.innerHTML+="&nbsp"+"@" + name+ "&nbsp";
      //this.$refs.chatInput.innerHTML+="@" + name;
       // this.$refs.chatInput.focus();
     this.Focus();
    },
    screenshot() {
       //截图
      this.ks.startScreenShot();
    
   
    },

 


    Morenews() {
      //查看更多消息
      this.isonecf=1;
     if(this.tempTotal<this.contenTotal){
       this.getChatHistory();
      //
      setTimeout(()=>{
         var div = document.getElementById("dialogue_box");  
      if(this.isOne)   
      {
        this.isOne=false;
        div.scrollTop= div.scrollHeight-this.scrollHeight-30;
      }else{
        div.scrollTop= div.scrollHeight-this.scrollHeight+85;
      }
      },350)
      
     }else{
       this.More=false;
     }
     
    },

 paseImg() {
 
   let that = this
  
    var imgReader = function (item) {
        var blob = item.getAsFile(),
            reader = new FileReader();
        var formData = new FormData();
        formData.append('blob', blob);
        reader.onloadend = function (e) {

      
         that.ImgArr1=e.target.result
           that.axios({
        method: "post",
        url: that.imgSrc + "api/user/uploadScreenshot",
         data: {
          token: window.localStorage.getItem("token"),
            base64str:e.target.result
        }
        
      }).then(res => {
       
        if (res.data.code == 0) {
          that.ImgArr=res.data.data
        that.ImgArrys.push(res.data.data)
         
        var  msg = "<img src='"+that.ImgArr+"' style='max-width:60%;max-height:250px;'/>";
       var htmlr=  document.getElementById('chatInput').innerHTML
        var imgs = htmlr.match(/<img[^>]+>/g);
      
        if(imgs)
        {
          var newList= imgs.filter(item=>{
                 if(item.includes('style')){
                   // document.getElementById('chatInput').innerHTML=item;
                   console.log(item)
                     return item
                 }
             })
              
             document.getElementById('chatInput').innerHTML=newList.join('')
          
        }
        
        $('#chatInput').append(msg);
          
         if(that.st==0){
         that.st=1;
        }

        } else {
          this.store.commit("hintMsg", "网络问题！");
          this.store.commit("hintShow", 1500);
        }
      });
           //显示图像
            // if(this.ImgArr!=e.target.result)
            // {
            //   this.ImgArr=e.target.result;
            //   var msg = "<img src='"+e.target.result+"' style='max-width:60%;max-height:250px;'/>";
            //   $('#chatInput').append(msg);
            // }
        };
        reader.readAsDataURL(blob);
    };
    window.addEventListener("paste",function(e){
    // document.getElementById('chatInput').innerHTML+= e.srcElement.innerText.replace(/<\/?.+?>/g,"")
    // console.log(e.srcElement.innerText.replace(/<\/?.+?>/g,""))
        that.ispaste=true;//粘贴
      var clipboardData = e.clipboardData,
        i = 0,
        items, item, types,file = null;;
        if (clipboardData) {
          items = clipboardData.items;
          if (!items) {
              return;
          }
          item = items[0];
          types = clipboardData.types || [];
          for (; i < types.length; i++) {
              if (types[i] === 'Files') {
                  item = items[i];
                  break;
              }
          }
          if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
              imgReader(item);
          }
        }
    });
  },
Focus(){
  // 始终聚焦在文本末尾
   var el=document.getElementById('chatInput');
    //el=el[0];  //jquery 对象转dom对象
    el.focus();
    if($.support.msie){
        var range = document.selection.createRange();
        this.last = range;
        range.moveToElementText(el);
        range.select();
        document.selection.empty(); //取消选中
    } else {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    }
},

  getBannedOut(useid,name){
     let that = this
    if(that.Administrators!=0)
    {
     // console.log(this.Administrators)
       that.UserId=useid;
       document.body.onclick = function(){that.rightclickShow=false}
       this.axios({
        method: "post",
        url: this.chatUrl + "api/user/getBannedOut",
        data: {
          token: window.localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code == 0) {
         that.rightclickShow=true;
          that.itemList = res.data.data;
        } else {
          //this.isLoading = false;
        }
      });
    }
      
  },
   confige(i,val){
     this.tiren=true;
     var sti=i-1
     this.valuE=val;
     if(sti<2){
       this.outstring='禁言'
     }else{
       this.outstring='踢人'
     }
    this.connt=i;
   },

  //禁言类型
  sendBannedAndOUt(){
       this.axios({
        method: "post",
        url: this.chatUrl + "api/user/sendBannedAndOUt",
        data: {
          token: window.localStorage.getItem("token"),
          id:this.UserId,
          type:this.connt
        }
      }).then(res => {
        if (res.data.code == 0) {
           this.tiren=false
           this.valuE="",
           this.UserId="";
           this.store.commit("hintMsg", res.data.msg);
           this.store.commit("hintShow", 1500);
           setTimeout(()=>{
             this.$refs.memberList.getChatUserList() 
           },3000)
             localStorage.setItem("chatB", 0);
        } else {
         // this.isLoading = false;
          this.tiren=false;
          this.store.commit("hintMsg", res.data.msg);
          this.store.commit("hintShow", 1500);
        }
      });
  },

  //取消禁言
  Cancel(){
  this.tiren=false;
  this.valuE="",
  this.UserId="";
  }
  }
};
</script>
<style scoped>
#chatBox {
  width: 100%;
  height: 100%;
   box-shadow: 2px 4px 5px 6px rgba(215, 215, 215, 5);
}
.chatBox {
  width: 65rem;
  height: 100%;
  background-color: #fff;
  border-radius: 0.5rem;
}
.chatBox2 {
  width: 61rem;
  height: 44rem;
  background-color: #fff;
  position: absolute;
  top: calc((100% - 44rem) / 2);
  left: calc((100% - 58rem) / 2);
  border-radius: 0.5rem;
}
.boxTop {
  width: 58rem;
  height: 3rem;
  background-color: #11a23c;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.5rem /* 24/16 */;
  color: #fff;
  padding: 0 1.5rem /* 24/16 */;
}
.weihuImg {
  width: 100%;
  height: calc(100% - 3rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
.weihuImg > img {
  width: 20%;
}
.boxTop1 {
  width: 65.5rem;
}
.boxTop > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.boxTop > div > img {
  width: 1.75rem;
  margin-right: 1.1875rem;
}
.boxTop > img {
  width: 1.1875rem;
  cursor: pointer;
}
.BigContent {
  height: calc(100% - 3rem);
  position: relative;
}
.historyContent {
  height: 100%;
  position: absolute;
  top: 0;
  right: -22.5rem;
}
.memberList {
  width: 15rem;
  background-color: #fff;
  height: calc(100% + 3rem);
  position: absolute;
  top: 0;
  right: -15rem;
}
.bothBox {
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 186;
}
.boxContent {
  height: 100%;
  width: 100%;
 
}
.boxInfo {
  background-color: #f2f2f2;
  padding: 1.5rem;
  height: calc(100% - 13.5rem);
  position: relative;
  overflow-y: auto;
   overflow-x: hidden;
   z-index: 0.1;
}
/* .boxInfo::-webkit-scrollbar {
     display: none;   
} */
.boxInput {
  height: 13.5rem;
  z-index: 188;
 
}
.input_top {
  padding: 1rem 1.625rem 0;
  text-align: left;
  position: relative;
}
.input_top > img {
  width: 1.75rem /* 28/16 */;
  margin-right: 1rem;
  cursor: pointer;
}
.input_box {
  height: calc(100% - 3.3rem);
  position: relative;
}
.input_box > img {
  width: 100%;
  height: 100%;
}
.textareaDiv {
  width: 97%;
  height: 80%;
  padding: 0.5rem;
  border: none;
  resize: none;
  text-align: left;
  border: 1px solid rebeccapurple;
}
textarea {
  width: 97%;
  height: 80%;
  padding: 0.5rem;
  border: none;
  resize: none;
}
.btn {
  position: absolute;
  bottom: 1.25rem;
  right: 7.125rem;
  width: 6.625rem;
  height: 2.375rem /* 38/16 */;
  line-height: 2.375rem;
  text-align: center;
  font-size: 1rem;
  border: 0.0625rem solid #dcdcdc;
  border-radius: 0.25rem /* 4/16 */;
  cursor: pointer;
  color: #404040;
  background-color: #fff;
}
.btn1 {
  width: 12rem /* 240/16 */;
  height: 3.5rem /* 56/16 */;
  border: unset;
  background: linear-gradient(
    -90deg,
    rgba(160, 199, 59, 1),
    rgba(18, 162, 60, 1)
  );
  border-radius: 1.75rem /* 28/16 */;
  color: #fffefe;
  font-size: 1.25rem /* 20/16 */;
  cursor: pointer;
  line-height: 3.5rem;
}
.sendBtn {
  right: 1.25rem;
  background-color: #43ae36;
  color: #fff;
}
.history {
  position: absolute;
  right: 0;
  top: 1rem;
}
input[type="file"] {
  position: absolute;
  left: 4.7rem;
  /* left: 7.8rem; */
  top: 1rem;
  opacity: 0;
  z-index: 8888;
  height: 100%;
  width: 1.75rem /* 28/16 */;
  
  /* filter: alpha(opacity=0); */
  cursor: pointer;
}
.others {
  padding-top: 1em;
  position: relative;
  display: flex;
  margin-bottom: 1.5rem /* 24/16 */;
  margin-top: 1.5rem /* 24/16 */;
}
.others:nth-child(1) {
  margin-top: 1.125rem /* 18/16 */;
}
.others > div {
  display: flex;
}
.oneself > div {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.others_img {
  width: 4.125rem /* 66/16 */;
  height: 4.125rem /* 66/16 */;
  margin-right: 0.75rem;
  background-color: #fff;
  border-radius: 50%;
  cursor: pointer;
}
.oneself {
  margin-bottom: 1.5rem /* 24/16 */;
}
.oneself_img {
  width: 4.125rem /* 66/16 */;
  height: 4.125rem /* 66/16 */;
  margin-left: 0.75rem;
  background-color: #fff;
  border-radius: 50%;
  cursor: pointer;
}
.others_img img,
.oneself_img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.others_content {
  padding: 0.875rem /* 14/16 */;
  max-width: 14rem /* 224/16 */;
  word-wrap: break-word;
  background-color: #fff;
  box-shadow: 0 0.25rem 0.4375rem 0 rgba(0, 0, 0, 0.05);
  border-bottom-left-radius: 1.625rem /* 26/16 */;
  border-bottom-right-radius: 1.625rem /* 26/16 */;
  border-top-right-radius: 1.625rem /* 26/16 */;
  text-align: left;
  display: inline-block;
  float: left;
}
.others_name,
.oneself_name {
  color: #858585;
  font-size: 0.875rem /* 14/16 */;
  text-align: left;
}
.oneself_name {
  text-align: right;
}
.oneself_content {
  color: #fff;
  padding: 0.875rem /* 14/16 */;
  max-width: 14rem /* 224/16 */;
  word-wrap: break-word;
  background-color: #84d645;
  box-shadow: 0 0.25rem 0.4375rem 0 rgba(0, 0, 0, 0.05);
  border-bottom-left-radius: 1.625rem /* 26/16 */;
  border-bottom-right-radius: 1.625rem /* 26/16 */;
  border-top-left-radius: 1.625rem /* 26/16 */;
  text-align: left;
  display: inline-block;
  float: right;
}
.chatPlazatime {
  position: absolute;
  width: 100%;
  top: 0;
  justify-content: center;
  font-size: 0.75rem;
  color: #a3a3a3;
}
.chatPlazatime1 {
  width: 100%;
  justify-content: center;
  font-size: 0.75rem;
  color: #a3a3a3;
  padding-bottom: 1em;
}
/* 时间*/
.chatPlazatime2 {
  width: 100%;
  justify-content: center;
  font-size: 0.75rem;
  color: #a3a3a3;
  padding-bottom: 1em;
  line-height: 2.25rem; /* 20/16 */
}
.van_loading {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 100%;
  height: calc(100% - 10.5rem);
  top: 0;
  left: 0;
}
.van_loading div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.3rem 1rem;
  border-radius: 0.2rem;
  color: rgba(0, 0, 0, 0.3);
  opacity: 0.9;
}
.vanloading {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 46rem;
  height: 30rem;
  top: 0;
  left: 10rem;
}
.vanloading div {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  padding: 0.3rem 1rem;
  border-radius: 0.2rem;
  color: #fff;
  opacity: 0.9;
  
}
.facePhoto {
  width: 2rem;
}
.chatPhoto {
  max-width:35rem;
}
.AtUser {
  width: 15rem;
  position: absolute;
  bottom: 14rem;
  right: 1rem;
  height: 2.5625rem;
  z-index: 8888;
}
.name_me {
  position: absolute;
  right: -0.875rem /* 14/16 */;
  height: 2.5625rem /* 41/16 */;
  line-height: 2.5625rem /* 41/16 */;
  border: 1px solid rgba(238, 238, 238, 1);
  font-size: 0.875rem /* 14/16 */;
  color: #18c019;
  display: flex;
  align-items: center;
  border-radius: 1.25rem /* 20/16 */;
  padding-right: 0.5rem;
  background-color: #fff;
  padding-left: 0.5rem;
}
.name_me > img {
  width: 2rem;
  height: 2rem;
  cursor: pointer;
}
.atUserList {
  width: 10rem;
  height: 10.625rem;
  background: rgba(255, 255, 255, 1);
  border: 0.0625rem solid rgba(228, 228, 228, 1);
  position: absolute;
  top: -10.625rem;
  left: 1rem;
  overflow: auto;
  z-index: 9999;
}
.atUserList::-webkit-scrollbar {
  display: none;
}
.atUserList > li {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 0.5rem;
}
.img {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
  border-radius: 50%;
}
.atUserList > li > span {
  font-size: 0.875rem;
}
.bigPhoto {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}
.bigPhoto > img {
  max-width: 60%;
  max-height: 60%;
}
#emtionBox {
  background-color: #fff;
  box-shadow: 0.0625rem 0.0625rem 0.0625rem 0.0625rem rgb(243, 243, 243);
  border-radius: 0.5rem;
  position: absolute;
  width: 40rem;
  height: 17rem;
  overflow: auto;
  z-index: 8888;
  bottom: 12rem;
  left: 1rem;
}
#emtionBox::-webkit-scrollbar {
  display: none;
}

/* 踢出*/
.Kickout {
  position: relative;
  text-align: center;
  font-size: 0.75rem /* 12/16 */;
  color: #a3a3a3;
  white-space: nowrap;
  display: inline;
  background: #dcdcdc;
}

.Kickout span {
  color: #11a23c;
}
/* 艾特 列表样式 */
.atUserList {
  width: 10rem;
  height: 10.625rem;
  background: rgba(255, 255, 255, 1);
  border: 0.0625rem solid rgba(228, 228, 228, 1);
  position: absolute;
  top: -10.625rem;
  left: 1rem;
  overflow: auto;
}
.atUserList::-webkit-scrollbar {
  display: none;
}
.atUserList > li {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 0.5rem;
}
.atUserList > li > img {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
  border-radius: 50%;
}
.atUserList > li > span {
  font-size: 0.875rem;
}
.level {
  background: rgba(255, 241, 223, 1);
  border: 0.0625rem solid rgba(255, 163, 60, 1);
  border-radius: 0.125rem /* 2/16 */;
  font-size: 0.75rem;
  height: 1.5em;
  line-height: 1.5em;
  padding: 0 0.5rem;
  text-align: center;
  color: #ffa33c;
  margin: 0 0.5rem;
}
.more {
  font: 0.875rem /* 14/16 */;
  color: #999;
  text-align: center;
  position: relative;
  cursor:pointer;
}
.jiet{
  height: 4rem /* 16/16 */
}
.popBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.popBox1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.phoneBox {
  width: 31.25rem /* 500/16 */;
  background-color: #fff;
  box-shadow: 0px 6px 23px 0px rgba(0, 0, 0, 0.09);
  border-radius: 0.5rem;
  position: absolute;
  top: calc((100% - 15rem /* 240/16 */) / 2);
  left: calc((100% - 31.25rem) / 2);
 
  
}
.phone_top {
  height: 3rem;
  font-size: 1.625rem /* 26/16 */;
  line-height: 3rem;
  border-radius: 0.5rem 0.5rem 0px 0px;
  background: linear-gradient(
    -90deg,
    rgba(17, 162, 60, 1),
    rgba(161, 199, 59, 1)
  );
  
  color: #fffefe;
  text-align: center;
}
.phone_top1 {
  height: 4rem;
  font-size: 1.4rem /* 26/16 */;
  line-height: 4rem;
  border-radius: 0.5rem 0.5rem 0px 0px;
  background: linear-gradient(
    -90deg,
    rgba(17, 162, 60, 1),
    rgba(161, 199, 59, 1)
  );
  
  color: #fffefe;
  text-align: center;
}

.tipContent{
  margin: 0.5rem 0;
}
.btnBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 1rem 0;
}
.btn20 {
  width: 12rem /* 240/16 */;
  height: 3.5rem /* 56/16 */;
  border: unset;
  background: linear-gradient(
    -90deg,
    rgba(160, 199, 59, 1),
    rgba(18, 162, 60, 1)
  );
  border-radius: 1.75rem /* 28/16 */;
  color: #fffefe;
  font-size: 1.25rem /* 20/16 */;
  cursor: pointer;
  line-height: 3.5rem;
}
.btn2 {
  background: linear-gradient(-90deg, rgb(212, 212, 212), rgb(205, 207, 206));
}
.chatInput {
  margin-top: 3px;
  width: 100%;
  height: 100%;
  background: rgba(247, 247, 247, 1);
  /*padding: 0 .9375rem 15/16 1.25rem 20/16; */
  padding: 0 .9375rem /* 15/16 */ 1.25rem /* 20/16 */;
  outline: none;
  overflow-x: hidden;
  box-sizing: border-box;
  text-align: left;
  line-height: 2.75rem ;/* 20/16 */
  -moz-user-select: text;
-webkit-user-select: text;
-ms-user-select: text;
-khtml-user-select: text;
user-select: text;
word-wrap:break-word;
}
.rightClick{
  width:23.125rem /* 450/16 */; 
  background-color: #fff;
  position: absolute; 
  left: calc((100% - 21.875rem) / 2);
  top: 11rem;
  z-index: 99999;
  border-radius: 0.5rem;
  overflow: hidden;
}
.rightClick ul{
  padding: 0 2rem;
}
.rightClick ul li{
  display: flex;
  justify-content: space-between;
  width: 100%;
  line-height: 2.8rem;
  padding:0 1.25rem /* 20/16 */;
  cursor: pointer;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  font-size: 1.2rem;
}
.rightClick ul:last-child li{
  border-bottom: none;
}
.chatPhoto1 {
  max-width:35rem;
}


</style>


// WEBPACK FOOTER //
// src/components/chatPlaza/chatBox.vue